import apiClient, { PaginatedResponse } from './client';

export interface AutomotiveService {
    id: number;
    service_type: string;
    name: string;
    name_ar?: string;
    logo?: string;
    short_description?: string;
    short_description_ar?: string;
    contact_phone?: string;
    website_url?: string;
    latitude?: number;
    longitude?: number;
    address?: string;
    address_ar?: string;
    is_featured: boolean;
    is_active: boolean;
    sort_order: number;
    distance_km?: number;
}

export interface ServiceAssistanceRequest {
    id: number;
    service: number;
    service_name?: string;
    customer_name?: string;
    user_latitude?: number;
    user_longitude?: number;
    status: 'pending' | 'accepted' | 'en_route' | 'completed' | 'cancelled';
    notes?: string;
    created_at?: string;
}

export interface ServicesFilter {
    service_type?: string;
    is_featured?: boolean;
    search?: string;
    lat?: number;
    lng?: number;
    ordering?: string;
    page?: number;
    page_size?: number;
}

export const servicesApi = {
    // Services Getters
    getServices: async (filters?: ServicesFilter) => {
        const { data } = await apiClient.get<PaginatedResponse<AutomotiveService>>('/services/services/', { params: filters });
        return data;
    },

    getService: async (id: number) => {
        const { data } = await apiClient.get<AutomotiveService>(`/services/services/${id}/`);
        return data;
    },

    // Assistance Requests
    getRequests: async () => {
        const { data } = await apiClient.get<PaginatedResponse<ServiceAssistanceRequest>>('/services/requests/');
        return data;
    },

    createRequest: async (requestData: Partial<ServiceAssistanceRequest>) => {
        const { data } = await apiClient.post<ServiceAssistanceRequest>('/services/requests/', requestData);
        return data;
    },

    cancelRequest: async (id: number) => {
        const { data } = await apiClient.patch<ServiceAssistanceRequest>(`/services/requests/${id}/`, { status: 'cancelled' });
        return data;
    }
};
